module.exports = __webpack_public_path__ + "img/title-box.ddb32b0a.png";